import { z } from 'zod'

export const ManagerSortKeySchema = z.enum(['createdAt', 'email', 'name', 'status'])

export const ManagerSortKey = ManagerSortKeySchema.enum

export type ManagerSortKey = z.infer<typeof ManagerSortKeySchema>
